(() => {
  'use strict';
  if (!document.body.classList.contains('pt-pdp-master') || window.__ptPdpShared) return;
  window.__ptPdpShared = true;

  const clean = (value = '') => String(value).replace(/\s+/g, ' ').trim();
  const giftRootSelector = '#pt-tea-gift-offer';
  const formatEuro = (raw) => {
    const value = Number(String(raw).replace(',', '.'));
    if (!Number.isFinite(value)) return null;
    if (value === 0) return '0,00 €';
    return `${new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)} €`;
  };

  const markGiftTitle = (card) => {
    const selectors = '[class*="ProductTitle"],[class*="productTitle"],[class*="product-title"],[class*="title"],h3,h4';
    let title = Array.from(card.querySelectorAll(selectors)).find((node) => {
      const text = clean(node.textContent);
      return text.length > 2 && !/^(gratis|free|auswählen|hinzufügen|add|remove|löschen)/i.test(text) && !/[€]|\bEUR\b/i.test(text);
    });
    if (!title) title = Array.from(card.querySelectorAll('p,span,strong')).find((node) => {
      const text = clean(node.textContent);
      return text.length > 3 && text.length < 120 && !/[€]|\bEUR\b/i.test(text) && !/^(gratis|free|auswählen|hinzufügen|add|remove|löschen)/i.test(text);
    });
    if (title) title.dataset.ptGiftTitle = 'true';
    return title;
  };

  const localizeGiftPrices = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(node.parentElement.tagName)) continue;
      const original = node.nodeValue || '';
      if (!/(?:€|EUR)/i.test(original)) continue;
      const next = original
        .replace(/€\s*(\d+(?:[.,]\d{1,2})?)/gi, (match, amount) => formatEuro(amount) || match)
        .replace(/(\d+(?:[.,]\d{1,2})?)\s*(?:EUR|€)/gi, (match, amount) => formatEuro(amount) || match);
      if (next !== original) node.nodeValue = next;
      node.parentElement.dataset.ptGiftPrice = 'true';
      if (/0,00\s*€/i.test(next)) node.parentElement.dataset.ptGiftPriceKind = 'free';
    }
  };

  const enhanceGift = (section) => {
    const app = section?.querySelector('[data-pt-gift-app]') || section;
    if (!app) return;
    Array.from(app.querySelectorAll('.gfgBuyXGetYProductCardWrapper')).forEach((card) => {
      card.dataset.ptGiftCard = 'true';
      const title = markGiftTitle(card);
      const titleText = clean(title?.textContent);
      const image = card.querySelector('.gfgBuyXGetYProductImage,img');
      if (image) {
        image.loading = 'lazy';
        image.decoding = 'async';
        if (titleText) image.alt = titleText;
        else if (!clean(image.alt)) image.alt = 'PARATITO Zubehör';
      }
      const button = card.querySelector('.gfgBuyXGetYProductBtn');
      if (button) {
        const text = clean(button.textContent);
        const lower = text.toLowerCase();
        let target = '';
        if (/hinzufügen|\badd\b/.test(lower)) target = 'Gratis hinzufügen';
        else if (/auswählen|select|choose|wählen/.test(lower)) target = 'Auswählen';
        if (target && text !== target) button.textContent = target;
        if (titleText && !clean(button.getAttribute('aria-label'))) button.setAttribute('aria-label', `${titleText}: ${target || text}`);
      }
    });
    localizeGiftPrices(app);
  };

  let scheduleCartSync = () => {};
  const initGift = () => {
    const section = document.querySelector(giftRootSelector);
    if (!section || section.dataset.ptSharedGiftInit === 'true') return;
    section.dataset.ptSharedGiftInit = 'true';
    enhanceGift(section);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        enhanceGift(section);
      });
    }).observe(section, { childList: true, subtree: true });
    section.addEventListener('click', (event) => {
      const action = event.target.closest('.gfgBuyXGetYProductBtn');
      if (!action || action.disabled || action.getAttribute('aria-disabled') === 'true') return;
      window.setTimeout(() => scheduleCartSync(80), 180);
      window.setTimeout(() => scheduleCartSync(80), 700);
    });
  };

  const syncBaseStickyTitle = () => {
    const title = clean(document.querySelector('.shopify-section--main-product h1')?.textContent);
    if (!title) return;
    document.querySelectorAll('product-quick-add .bold.truncate-text').forEach((node) => { node.textContent = title; });
  };

  const initSticky = () => {
    const sticky = document.querySelector('product-quick-add');
    const mainCta = document.querySelector('.shopify-section--main-product buy-buttons [type="submit"]');
    const footer = document.querySelector('footer,.shopify-section-group-footer-group');
    if (!sticky || !mainCta || sticky.dataset.ptSharedStickyInit === 'true') return;
    sticky.dataset.ptSharedStickyInit = 'true';
    sticky.querySelectorAll('variant-media img').forEach((image) => {
      image.dataset.ptStickyImage = 'true';
      if (!clean(image.alt)) image.alt = 'PARATITO Produkt';
    });
    syncBaseStickyTitle();
    if (!('IntersectionObserver' in window)) return;
    const state = { cta: true, footer: false };
    const sync = () => sticky.classList.toggle('pt-shared-sticky-hidden', state.cta || state.footer);
    new IntersectionObserver((entries) => { state.cta = entries.some((entry) => entry.isIntersecting); sync(); }, { threshold: .05 }).observe(mainCta);
    if (footer) new IntersectionObserver((entries) => { state.footer = entries.some((entry) => entry.isIntersecting); sync(); }, { threshold: .01 }).observe(footer);
    sync();
  };

  const improveA11y = () => {
    document.querySelectorAll('cart-drawer [is="close-button"],cart-drawer .drawer__close-icon').forEach((control) => {
      if (!clean(control.getAttribute('aria-label')) && !clean(control.textContent)) control.setAttribute('aria-label', 'Warenkorb schließen');
    });
    document.querySelectorAll('.product-gallery [is="product-zoom-button"]').forEach((control) => {
      if (!clean(control.getAttribute('aria-label')) && !clean(control.textContent)) control.setAttribute('aria-label', 'Produktbild vergrößern');
    });
  };

  const localizeReviews = () => {
    document.querySelectorAll('.jdgm-rev-widg').forEach((widget) => {
      const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        let value = node.nodeValue || '';
        value = value.replace(/Sort by:?/gi, 'Sortieren nach').replace(/Write a review/gi, 'Bewertung schreiben').replace(/Customers? Reviews?/gi, 'Kundenbewertungen').replace(/Based on (\d+) reviews?/gi, 'Basierend auf $1 Bewertungen').replace(/Read more/gi, 'Mehr lesen').replace(/Show more/gi, 'Mehr anzeigen').replace(/Show less/gi, 'Weniger anzeigen').replace(/\b([0-5])\.(\d{2})\b/g, '$1,$2');
        if (value !== node.nodeValue) node.nodeValue = value;
      }
    });
    document.querySelectorAll('.jdgm-sort-dropdown,.jdgm-sort-dropdown-wrapper select').forEach((select) => {
      select.setAttribute('aria-label', 'Sortieren nach');
      Array.from(select.options || []).forEach((option) => {
        const next = option.textContent.replace('Most Recent', 'Neueste').replace('Highest Rating', 'Höchste Bewertung').replace('Lowest Rating', 'Niedrigste Bewertung').replace('Most Helpful', 'Hilfreichste');
        if (next !== option.textContent) option.textContent = next;
      });
    });
  };

  const initReviewObserver = () => {
    const main = document.querySelector('main') || document.body;
    if (main.dataset.ptSharedReviewsInit === 'true') return;
    main.dataset.ptSharedReviewsInit = 'true';
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; localizeReviews(); });
    }).observe(main, { childList: true, subtree: true });
    localizeReviews();
  };

  const optimizeVideos = () => {
    document.querySelectorAll('.product-gallery media-carousel[autoplay]').forEach((carousel) => carousel.removeAttribute('autoplay'));
    document.querySelectorAll('.product-gallery video').forEach((video) => {
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.preload = 'metadata';
      if (!video.paused) video.pause();
    });
  };

  const cleanLegacy = () => document.querySelectorAll('.paratito-product-guide-mount').forEach((node) => node.remove());
  const nativeFetch = window.fetch.bind(window);
  let cartTimer = 0;
  let cartSyncing = false;
  let cartPending = false;

  const renderAuthoritativeCart = async () => {
    if (cartSyncing) { cartPending = true; return; }
    cartSyncing = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const [cartResponse, sectionResponse] = await Promise.all([
        nativeFetch(`${root}cart.js`, { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' }),
        nativeFetch(`${root}cart?sections=cart-drawer`, { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      ]);
      if (!cartResponse.ok || !sectionResponse.ok) return;
      const cart = await cartResponse.json();
      const sections = await sectionResponse.json();
      const html = sections?.['cart-drawer'];
      const current = document.querySelector('#cart-drawer');
      if (current && html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('#cart-drawer');
        if (fresh) {
          const wasOpen = current.hasAttribute('open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.setAttribute('open', '');
          current.dataset.ptCartTotal = String(cart.total_price);
          improveA11y();
        }
      }
      document.dispatchEvent(new CustomEvent('pt:cart-reconciled', { detail: { itemCount: cart.item_count, totalPrice: cart.total_price, currency: cart.currency } }));
    } catch (error) {
      console.warn('[PARATITO] Cart reconciliation failed', error);
    } finally {
      cartSyncing = false;
      if (cartPending) { cartPending = false; scheduleCartSync(80); }
    }
  };

  scheduleCartSync = (delay = 140) => { clearTimeout(cartTimer); cartTimer = window.setTimeout(renderAuthoritativeCart, delay); };
  const isCartMutation = (url, method) => {
    try {
      const parsed = new URL(String(url), location.origin);
      return /\/cart\/(add|change|update|clear)(?:\.js)?$/.test(parsed.pathname) && String(method || 'GET').toUpperCase() !== 'GET';
    } catch (_) { return false; }
  };

  window.fetch = async (...args) => {
    const request = args[0];
    const init = args[1] || {};
    const url = typeof request === 'string' ? request : request?.url;
    const method = init.method || (request instanceof Request ? request.method : 'GET');
    const response = await nativeFetch(...args);
    if (isCartMutation(url, method)) { scheduleCartSync(100); window.setTimeout(() => scheduleCartSync(80), 420); }
    return response;
  };

  if (window.XMLHttpRequest && !window.__ptCartXhrGuard) {
    window.__ptCartXhrGuard = true;
    const open = XMLHttpRequest.prototype.open;
    const send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this.__ptCartMethod = method;
      this.__ptCartUrl = url;
      return open.call(this, method, url, ...rest);
    };
    XMLHttpRequest.prototype.send = function(...args) {
      if (isCartMutation(this.__ptCartUrl, this.__ptCartMethod)) this.addEventListener('loadend', () => { scheduleCartSync(100); window.setTimeout(() => scheduleCartSync(80), 420); }, { once: true });
      return send.apply(this, args);
    };
  }

  const boot = () => { initGift(); initSticky(); improveA11y(); initReviewObserver(); optimizeVideos(); cleanLegacy(); syncBaseStickyTitle(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(boot));
  document.addEventListener('variant:change', () => window.setTimeout(() => { initSticky(); optimizeVideos(); syncBaseStickyTitle(); }, 80));
})();